import { apiService } from "../../../../components/api/apiService";

const BASE = "/api/McpToolRegistrations";

export interface RegisterMCPToolPayload {
  displayName: string;
  category: string;
  endpoint: string;
  description: string;
  isActive: boolean;
}

export interface MCPToolRegistrationRow {
  id: string;
  toolId: string;
  tenantId: string;
  displayName: string;
  category: string;
  endpoint: string;
  description: string | null;
  isActive: boolean;
  createdBy: string;
  createdDate: string;
  updatedBy: string;
  updatedDate: string;
}

function mapToolFromApi(raw: Record<string, unknown>): MCPToolRegistrationRow {
  return {
    id: String(raw.id ?? raw.Id ?? ""),
    toolId: String(raw.toolId ?? raw.ToolId ?? ""),
    tenantId: String(raw.tenantId ?? raw.TenantId ?? ""),
    displayName: String(raw.displayName ?? raw.DisplayName ?? ""),
    category: String(raw.category ?? raw.Category ?? ""),
    endpoint: String(raw.endpoint ?? raw.Endpoint ?? ""),
    description:
      raw.description != null
        ? String(raw.description)
        : raw.Description != null
          ? String(raw.Description)
          : null,
    isActive: Boolean(raw.isActive ?? raw.IsActive),
    createdBy: String(raw.createdBy ?? raw.CreatedBy ?? ""),
    createdDate: String(raw.createdDate ?? raw.CreatedDate ?? ""),
    updatedBy: String(raw.updatedBy ?? raw.UpdatedBy ?? ""),
    updatedDate: String(raw.updatedDate ?? raw.UpdatedDate ?? ""),
  };
}

export const mcpToolRegistrationsService = {
  async list(): Promise<MCPToolRegistrationRow[]> {
    const data = await apiService.get(BASE, {}, "backend");
    const list = data?.tools ?? data?.Tools ?? [];
    if (!Array.isArray(list)) return [];
    return list.map((item: Record<string, unknown>) => mapToolFromApi(item));
  },

  async register(payload: RegisterMCPToolPayload): Promise<MCPToolRegistrationRow> {
    const data = await apiService.post(
      BASE,
      {
        displayName: payload.displayName,
        category: payload.category,
        endpoint: payload.endpoint,
        description: payload.description,
        isActive: payload.isActive,
      },
      "backend"
    );
    const raw =
      data && typeof data === "object"
        ? ((data as Record<string, unknown>).tool ??
          (data as Record<string, unknown>).Tool ??
          data)
        : data;
    if (raw != null && typeof raw === "object") {
      return mapToolFromApi(raw as Record<string, unknown>);
    }
    return mapToolFromApi({});
  },

  async update(id: string, payload: RegisterMCPToolPayload): Promise<MCPToolRegistrationRow> {
    const data = await apiService.put(
      `${BASE}/${id}`,
      {
        displayName: payload.displayName,
        category: payload.category,
        endpoint: payload.endpoint,
        description: payload.description,
        isActive: payload.isActive,
      },
      "backend"
    );
    const raw =
      data && typeof data === "object"
        ? ((data as Record<string, unknown>).tool ??
          (data as Record<string, unknown>).Tool ??
          data)
        : data;
    if (raw != null && typeof raw === "object") {
      return mapToolFromApi(raw as Record<string, unknown>);
    }
    return mapToolFromApi({});
  },

  async delete(id: string): Promise<void> {
    await apiService.delete(`${BASE}/${id}`, "backend");
  },
};
